import { MASTER_CODES } from './languages';

export const DINER_LANG_KEY = 'cometqr_diner_lang';
const SUPPORTED = MASTER_CODES;

export function detectInitialLang() {
  try {
    const saved = localStorage.getItem(DINER_LANG_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (e) { /* ignore */ }
  const cands = (typeof navigator !== 'undefined')
    ? [navigator.language, ...(navigator.languages || [])] : [];
  for (const c of cands) {
    const p = (c || '').toLowerCase().slice(0, 2);
    if (SUPPORTED.includes(p)) return p;
  }
  return 'en';
}
